"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenArray = void 0;
const flattenArray = (fields) => {
    return fields.reduce((acc, field) => {
        if (field.componentType === 'grouped-fields' && field.fields) {
            return acc.concat((0, exports.flattenArray)(field.fields));
        }
        return acc.concat(field);
    }, []);
};
exports.flattenArray = flattenArray;
